/**
 * The assignable handlers, as `GET /collections/ageing/handlers` returns them:
 * `roster` is `[{ name, user_id }]`, where `user_id` is the identity provider's id
 * (null for a row from the fallback list, which has none).
 *
 * An assignment sends the id beside the name. The name is a display name the user
 * can edit, so the backend stores the id and My Actions matches on it; sending the
 * name alone leaves the record exposed to a rename.
 */

/**
 * The user id to send with `name`, or `undefined` when there is not exactly one.
 * A name shared by two users cannot be told apart by a name-keyed dropdown, so it
 * is sent without an id rather than with the wrong one. Throws when `roster` is not an
 * array (a name was given but the roster never arrived), so that cannot go unnoticed.
 */
export function handlerIdFor(roster, name) {
  if (!name) return undefined;
  if (!Array.isArray(roster)) {
    // a caller that never received the roster would otherwise assign with no id, silently
    throw new TypeError("handlerIdFor needs the handlers roster; pass it down from the page that loaded it");
  }
  const matches = roster.filter((h) => h?.name === name);
  if (matches.length !== 1) return undefined;
  return matches[0].user_id || undefined;
}

/** The roster out of a handlers response, tolerating an older server without one. */
export function rosterFrom(response) {
  return Array.isArray(response?.roster) ? response.roster : [];
}
